(function () {
    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        utils(
            module.exports,
            require('lodash'),
            require('underscore.string'),
            require('../../enums/metrics.js')
        );

    } else {
        utils(
            RivalIQ.module('utils.socialUrl'),
            window._,
            window.s,
            RivalIQ.enums
        );
    }

    function utils(exports, _, s, enums) {

        const nonHandles = exports.nonHandles = {};

        nonHandles.facebook = [
            'appcenter',
            'avb',
            'browse',
            'business',
            'campaign',
            'comments',
            'connect',
            'dialog',
            'events',
            'face',
            'feeds',
            'group',
            'group.php',
            'groups',
            'help',
            'home',
            'home.php',
            'images',
            'l',
            'law',
            'likes',
            'login',
            'media',
            'notes',
            'offsite_event',
            'offsite_event.php',
            'page',
            'pages',
            'photo',
            'plugins',
            'posts',
            'profile',
            'public',
            're',
            'reactions',
            'share',
            'share.php',
            'sharer',
            'sharer.php',
            'shares',
            'tr',
            'www',
            'zero'
        ];

        nonHandles.instagram = [
            'p',
            'stories',
            'v1'
        ];

        nonHandles.twitter = [
            'about',
            'hashtag',
            'home',
            'intent',
            'javascripts',
            'jobs',
            'login',
            'privacy',
            'search',
            'share',
            'signup',
            'start',
            'statuses',
            'tos',
            'translate',
            'widgets'
        ];

        nonHandles.youtube = [
            'c',
            'channel',
            'communities',
            'embed',
            'google',
            'iframe_api',
            'index',
            'page',
            'player_api',
            'playlist',
            'show',
            'static',
            'user',
            'v',
            'vi',
            'watch'
        ];

        nonHandles.tiktok = [
            'about',
            'community-guidelines',
            'feedback',
            'following',
            'foryou',
            'legal',
            'logout',
            'music',
            'safety',
            'tag',
            'upload'
        ];

        function filterNonHandles(channel, handle) {
            let result = handle;
            const channelNonHandles = nonHandles[channel] || [];
            if (_.includes(channelNonHandles, (handle || '').toLowerCase())) {
                result = null;
            }
            return result;
        }

        function getTokens(url, domain) {
            if (!url || typeof url !== 'string' || !s.trim(url)) {
                return [];
            }

            // url may be a bare host name such as "facebook.com"; ensure it
            // has a protocol component so URL() can parse it.
            if (!url.startsWith('http://') && !url.startsWith('https://')) {
                url = `https://${url}`;
            }

            try {
                const parsed = new URL(url);

                // We want the parsed hostname to equal the supplied domain (i.e. "facebook.com")
                // OR end with .domain (i.e. "www.facebook.com").
                if (parsed.hostname === domain || parsed.hostname.endsWith(`.${domain}`)) {
                    const tokens = _.compact(parsed.pathname.split('/'));
                    return tokens;
                }
            } catch (err) {
                // failed to parse
            }

            return [];
        }

        function getIdFromTokens(tokens, skip) {

            let id = tokens.shift();
            while (id && _.includes(skip, id.toLowerCase())) {
                id = tokens.shift();
            }
            return id;
        }

        function twitterUrlToHandleHelper(domain, url) {

            let result = null;
            const tokens = getTokens(url, domain);

            if (_.size(tokens)) {
                result = tokens[0];
                if (result?.[0] === '@') {
                    result = result.slice(1);
                }
            }

            return filterNonHandles('twitter', result);
        }

        const twitterDotComUrlToHandle = twitterUrlToHandleHelper.bind(this, 'twitter.com');
        const xDotComUrlToHandle = twitterUrlToHandleHelper.bind(this, 'x.com');

        exports.channelHandleToUrl = function (channelHandle, source) {
            if (source === enums.sources.FACEBOOK) {
                return exports.facebookHandleToUrl(channelHandle);
            } else if (source === enums.sources.INSTAGRAM) {
                return exports.instagramHandleToUrl(channelHandle);
            } else if (source === enums.sources.TWITTER) {
                return exports.twitterHandleToUrl(channelHandle);
            } else if (source === enums.sources.YOUTUBE) {
                return exports.youtubeHandleToUrl(channelHandle);
            } else if (source === enums.sources.TIKTOK) {
                return exports.tiktokHandleToUrl(channelHandle);
            }
        };

        exports.facebookHandleToUrl = function (channelHandle) {
            return `https://www.facebook.com/${channelHandle}/`;
        };

        exports.instagramHandleToUrl = function (channelHandle) {
            return `https://www.instagram.com/${channelHandle}/`;
        };

        exports.twitterHandleToUrl = function (channelHandle) {
            return `https://www.twitter.com/${channelHandle}`;
        };

        exports.youtubeHandleToUrl = function (channelHandle) {
            return `https://www.youtube.com/@${channelHandle}/`;
        };

        exports.tiktokHandleToUrl = function (channelHandle) {
            return `https://www.tiktok.com/@${channelHandle}`;
        };

        exports.facebookUrlToHandle = function (url) {

            let result = null;

            // patterns:
            // facebook.com/RivalIQ
            // facebook.com/<page-name-here>-<page-id-we-actually-want>
            // facebook.com/pages/page-name-here/page-id-we-actually-want

            const tokens = getTokens(url, 'facebook.com');
            if (_.size(tokens)) {

                if (tokens[0] === 'pages' && tokens.length >= 2) {
                    result = tokens[2];
                } else {
                    result = tokens[0];
                }

                if (result) {
                    const compoundPageName = result.split('-');
                    const suspectedId = compoundPageName[compoundPageName.length - 1];
                    if (compoundPageName.length > 1 && _.isFinite(Number(suspectedId))) {
                        result = suspectedId;
                    }
                }
            }

            return filterNonHandles('facebook', result);
        };

        exports.instagramUrlToHandle = function (url) {

            let result = null;

            // patterns:
            // instagram.com/rival_iq
            // instagram.com/stories/lucasgilman

            const tokens = getTokens(url, 'instagram.com');
            if (_.size(tokens)) {
                result = (tokens[0] === 'stories' && tokens.length > 1 ? tokens[1] : tokens[0]);
            }

            return filterNonHandles('instagram', result);
        };

        exports.twitterUrlToHandle = function (url) {

            const result = twitterDotComUrlToHandle(url) || xDotComUrlToHandle(url);
            return result;
        };

        exports.youtubeUrlToHandle = function (url) {

            let result = null;

            // patterns:
            // youtube.com/channel/<id>
            // youtube.com/user/<id>
            // youtube.com/c/<name>
            // youtube.com/<name>
            // youtube.com/@<name>

            const tokens = getTokens(url, 'youtube.com');
            if (_.size(tokens)) {
                result = getIdFromTokens(tokens, ['channel', 'user', 'c']);
                if (result?.[0] === '@') {
                    result = result.slice(1);
                }
            }

            return filterNonHandles('youtube', result);
        };

        exports.tiktokUrlToHandle = function (url) {

            let result = null;

            // patterns:
            // tiktok.com/@rivaliq

            const tokens = getTokens(url, 'tiktok.com');
            if (_.size(tokens)) {
                result = tokens[0];
                if (result?.[0] === '@') {
                    result = result.slice(1);
                }
            }

            return filterNonHandles('tiktok', result);
        };

        exports.getCanonicalUrl = function (url) {

            let handle;
            handle = exports.facebookUrlToHandle(url);
            if (handle) {
                return {
                    result: `https://www.facebook.com/${handle}/`,
                    source: enums.sources.FACEBOOK,
                    handle: handle
                };
            }
            handle = exports.instagramUrlToHandle(url);
            if (handle) {
                return {
                    result: `https://www.instagram.com/${handle}/`,
                    source: enums.sources.INSTAGRAM,
                    handle: handle
                };
            }
            handle = twitterDotComUrlToHandle(url);
            if (handle) {
                return {
                    result: `https://twitter.com/${handle}`,
                    source: enums.sources.TWITTER,
                    handle: handle
                };
            }
            handle = xDotComUrlToHandle(url);
            if (handle) {
                return {
                    result: `https://x.com/${handle}`,
                    source: enums.sources.TWITTER,
                    handle: handle
                };
            }
            handle = exports.youtubeUrlToHandle(url);
            if (handle) {
                const tokens = getTokens(url, 'youtube.com');
                return {
                    result: (tokens.length > 1 ? `https://www.youtube.com/${tokens[0]}/${handle}` : `https://www.youtube.com/@${handle}`),
                    source: enums.sources.YOUTUBE,
                    handle: handle
                };
            }
            handle = exports.tiktokUrlToHandle(url);
            if (handle) {
                return {
                    result: `https://www.tiktok.com/@${handle}`,
                    source: enums.sources.TIKTOK,
                    handle: handle
                };
            }
        };

        exports.getUrlChannel = function (url) {

            let handle;
            handle = exports.facebookUrlToHandle(url);
            if (handle) {
                return {
                    source: enums.sources.FACEBOOK,
                    handle: handle
                };
            }

            handle = exports.instagramUrlToHandle(url);
            if (handle) {
                return {
                    source: enums.sources.INSTAGRAM,
                    handle: handle
                };
            }

            handle = exports.twitterUrlToHandle(url);
            if (handle) {
                return {
                    source: enums.sources.TWITTER,
                    handle: handle
                };
            }

            handle = exports.youtubeUrlToHandle(url);
            if (handle) {
                return {
                    source: enums.sources.YOUTUBE,
                    handle: handle
                };
            }

            handle = exports.tiktokUrlToHandle(url);
            if (handle) {
                return {
                    source: enums.sources.TIKTOK,
                    handle: handle
                };
            }
        };

        exports.isSocialUrl = function (url) {
            return Boolean(exports.getUrlChannel(url));
        };

    }
})();
